import { useMemo } from "react";

const YT_RE = /(?:youtube\.com\/(?:shorts\/|watch\?v=|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/;
const TIKTOK_RE = /tiktok\.com\/(@[\w.-]+\/video\/(\d+)|.*\/video\/(\d+)|t\/([A-Za-z0-9]+))/i;
const VIMEO_RE = /vimeo\.com\/(\d+)/;
const INSTA_RE = /instagram\.com\/(?:p|reel|reels)\/([A-Za-z0-9_-]+)/;

export const detectVideo = (url) => {
  if (!url) return null;
  const u = url.trim();
  let m;
  if ((m = u.match(YT_RE))) {
    return { kind: "youtube", src: `https://www.youtube.com/embed/${m[1]}?rel=0` };
  }
  if ((m = u.match(VIMEO_RE))) {
    return { kind: "vimeo", src: `https://player.vimeo.com/video/${m[1]}` };
  }
  if ((m = u.match(TIKTOK_RE))) {
    const id = m[2] || m[3];
    if (id) return { kind: "tiktok", src: `https://www.tiktok.com/embed/v2/${id}` };
    return { kind: "tiktok-external", src: u };
  }
  if ((m = u.match(INSTA_RE))) {
    return { kind: "instagram", src: `https://www.instagram.com/reel/${m[1]}/embed` };
  }
  if (/\.(mp4|webm|ogg|mov)(\?.*)?$/i.test(u)) {
    return { kind: "file", src: u };
  }
  return { kind: "unknown", src: u };
};

export const VideoEmbed = ({ url, className = "" }) => {
  const info = useMemo(() => detectVideo(url), [url]);
  if (!info) return null;
  const baseCls = `w-full aspect-[9/16] max-h-[70vh] rounded-2xl overflow-hidden bg-black ${className}`;
  if (info.kind === "file") {
    return (
      <video
        data-testid="event-video-player"
        controls
        playsInline
        preload="metadata"
        className={baseCls}
        src={info.src}
      />
    );
  }
  if (info.kind === "unknown" || info.kind === "tiktok-external") {
    return (
      <a
        href={info.src}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="event-video-external"
        className={`${baseCls} flex items-center justify-center text-slate-400 hover:text-white`}
      >
        Watch clip ↗
      </a>
    );
  }
  return (
    <iframe
      data-testid="event-video-iframe"
      title="Event video"
      src={info.src}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      className={baseCls}
    />
  );
};
